import React from "react";
import { FooterText } from "./styels";

const Footer = () => {
  return (
    <FooterText>
      {/* <Nav theme={themeColors}> */}
        {/* Link to the home page */}
        {/* <Link target="_blank" to="https://www.innopark24.de/datenschutz">
          {t("privacy")}
        </Link> */}
        {/* Link to the imprint page */}
        {/* <Link target="_blank" to="https://www.innopark24.de/impressum">
          {t("imprint")}
        </Link> */}
      {/* </Nav> */}
    </FooterText>
  );
};

export default Footer;
